import { useState } from "react";
import type { OrderDetailData } from "@/api/hotel";

export default function HotelSection({
  data,
  subStatus,
  onAction,
}: {
  data?: OrderDetailData | null;
  subStatus: string;
  onAction: (a: string) => void;
}) {
  const [showPolicy, setShowPolicy] = useState(false);

  const hotel = data?.hotel;
  const room = data?.room;

  return (
    <div className="space-y-3">
      <div className="mx-4 bg-white rounded-2xl overflow-hidden">
        {/* 封面图 */}
        <img
          src={hotel?.cover || "https://readdy.ai/api/search-image?query=luxury%20five%20star%20beachfront%20resort%20hotel%20sanya%20yalong%20bay&width=400&height=200&seq=sod001&orientation=landscape"}
          alt={hotel?.name || "hotel"}
          className="w-full object-cover object-top"
          style={{ height: 170 }}
        />
        <div className="p-4">
          {/* 标题区 */}
          <div className="flex items-start justify-between gap-2 mb-3">
            <div>
              <span className="text-xs px-2 py-0.5 rounded-full font-semibold mr-2" style={{ background: "#FEF3C7", color: "#D97706" }}>
                {hotel?.star_text || "五星级"}
              </span>
              <div className="text-base font-bold text-gray-900 mt-1.5">{hotel?.name || "—"}</div>
              <div className="flex items-center gap-1.5 mt-1 text-xs text-gray-400">
                <i className="ri-map-pin-line" style={{ fontSize: 11 }} />
                {hotel?.address || "—"}
              </div>
            </div>
            <div
              className="w-10 h-10 flex items-center justify-center rounded-xl text-white font-bold text-sm flex-shrink-0"
              style={{ background: "#1E3A8A" }}
            >
              {hotel?.star ? `${hotel.star.toFixed(1)}` : "4.9"}
            </div>
          </div>

          {/* 信息网格 */}
          <div className="grid grid-cols-2 gap-2">
            {[
              { label: "入住日期", value: data?.check_in_date || "—", icon: "ri-calendar-check-line" },
              { label: "退房日期", value: data?.check_out_date || "—", icon: "ri-calendar-line" },
              { label: "房型", value: room?.name || "—", icon: "ri-hotel-bed-line" },
              { label: "早餐", value: "—" , icon: "ri-restaurant-line" },
              { label: "入住人数", value: data?.guest_count ? `${data.guest_count}位成人` : "—" , icon: "ri-user-line" },
              { label: "酒店电话", value: hotel?.contact_phone || "—", icon: "ri-phone-line" },
            ].map((item) => (
              <div key={item.label} className="rounded-xl p-2.5" style={{ background: "#F8F8F8" }}>
                <div className="flex items-center gap-1.5 mb-0.5">
                  <i className={item.icon} style={{ color: "#9CA3AF", fontSize: 11 }} />
                  <span className="text-xs text-gray-400">{item.label}</span>
                </div>
                <span className="text-xs font-semibold text-gray-800">{item.value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* 酒店设施 */}
      {hotel?.facilities && hotel.facilities.length > 0 && (
        <div className="mx-4 bg-white rounded-2xl p-4">
          <div className="text-sm font-bold text-gray-900 mb-2">酒店设施</div>
          <div className="flex flex-wrap gap-2">
            {hotel.facilities.map((f) => (
              <span key={f} className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs" style={{ background: "#F4F5F9", color: "#374151" }}>
                <i className="ri-checkbox-circle-line" style={{ color: "#10B981", fontSize: 12 }} />
                {f}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* 入住服务 */}
      {subStatus === "已入住" && (
        <div className="mx-4 bg-white rounded-2xl p-4">
          <div className="text-sm font-bold text-gray-900 mb-3">入住服务</div>
          <button
            onClick={() => onAction("aftersale")}
            className="w-full flex items-center justify-between py-3 cursor-pointer active:bg-gray-50 rounded-xl px-3 transition-colors"
            style={{ background: "#FEF2F2" }}
          >
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-xl" style={{ background: "#FEE2E2" }}>
                <i className="ri-customer-service-2-line" style={{ color: "#EF4444", fontSize: 16 }} />
              </div>
              <span className="text-sm font-medium" style={{ color: "#EF4444" }}>申请售后</span>
            </div>
            <i className="ri-arrow-right-s-line" style={{ color: "#FCA5A5", fontSize: 18 }} />
          </button>
        </div>
      )}

      {/* 取消政策 */}
      <div className="mx-4 bg-white rounded-2xl overflow-hidden">
        <button onClick={() => setShowPolicy(!showPolicy)} className="w-full flex items-center justify-between px-4 py-3.5 cursor-pointer">
          <span className="text-sm font-bold text-gray-900">取消政策</span>
          <i className={showPolicy ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} style={{ color: "#9CA3AF", fontSize: 18 }} />
        </button>
        {showPolicy && (
          <div className="px-4 pb-4 text-xs text-gray-500 leading-relaxed" style={{ borderTop: "1px solid #F5F5F5" }}>
            {data?.cancel_policy?.length ? (
              data.cancel_policy.map((p) => <p key={p.day}>{p.text}</p>)
            ) : (
              "入住前3天免费取消，入住前1-3天收取首晚房费，入住前1天内不可取消。如遇不可抗力，可联系客服协商处理。"
            )}
          </div>
        )}
      </div>
    </div>
  );
}
